<template>
  <store-recherche-provider
    :key="prefix"
    :name="prefix"
    :copy="storeCopy"
    :isTemporary="true">
    <liste-commandes-achat-fournisseur
      :nameStore="prefix"
      :isBonReception="isBonReception"
    />
  </store-recherche-provider>
</template>

<script>
import commandesAchatsFournisseur from '@/store/modules/achat/commandesAchatsFournisseur';
import StoreRechercheProvider from '@/components/general/store/storeRechercheProvider';
import ListeCommandesAchatFournisseur from '@/components/achat/commande/listeCommandeAchatFournisseurs';

export default {
  name: 'LCommandesAchatFournisseur',
  data() {
    return {
      storeCopy: commandesAchatsFournisseur,
    };
  },
  components: {
    StoreRechercheProvider,
    ListeCommandesAchatFournisseur,
  },
  computed: {
    isBonReception() {
      return this.$route.name === 'l.achat.bon_reception';
    },
    prefix() {
      return this.isBonReception ? 'listeBonReception' : 'listeCommandesAchat';
    },
    pageTrad() {
      return this.isBonReception ? 'bonReception' : 'commandes';
    },
  },
  mounted() {
    this.setInformationPage(this.$t(`pageAchat.${this.pageTrad}.liste`));
  },
};
</script>
